/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ProfileDialogRecharge.vue?vue&type=template&id=545ba70c&scoped=true"
import script from "./ProfileDialogRecharge.vue?vue&type=script&lang=js"
export * from "./ProfileDialogRecharge.vue?vue&type=script&lang=js"
import style0 from "./ProfileDialogRecharge.vue?vue&type=style&index=0&id=545ba70c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ba70c",
  null
  
)

export default component.exports